import React from "react";
import { useQuotationPopupFormContext } from "../hooks/use-quotation-popup-form";
import { TextField } from "../../shared/form-fields/text-field";
import { quotationPopupFormDefinition } from "../constants/form-fields-definition";
import phoneIconAsset from "../../../assets/icons/ic-phone.svg";

export const QuotationPopupContactPhoneField: React.FC = () => {
    const rhForm = useQuotationPopupFormContext();
    return (
        <TextField
            data-testid="QuotationPopupContactPhoneField"
            icon={<img src={phoneIconAsset} />}
            inputRef={rhForm.register}
            fieldDefinition={quotationPopupFormDefinition.contactPhone}
            rhForm={rhForm}
        />
    );
};
